import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs/observable/of'
import { catchError, debounceTime, exhaustMap, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { environment } from '../../../../../environments/environment'

import { AppState } from '../../../../store/app.state'
import * as fromTeam from '../selectors/team.selectors'
import * as fromMembers from '../selectors/members.selectors'
import * as App from '../../../../store/actions/app.actions'
import * as Members from '../actions/members.actions'

import { JeanService } from '../../../../api/api/services/jean.service'
import { cacheFirst } from '../../../utils/helpers'

@Injectable()
export class MembersEffects {

  constructor(private actions$: Actions,
              private store: Store<AppState>,
              private jeanService: JeanService) {
  }

  @Effect()
  addTeamMember$ = this.actions$.pipe(
    ofType(Members.ADD_TEAM_MEMBER),
    debounceTime(environment.debounceTime),
    map((action: Members.AddTeamMember) => action.payload),
    withLatestFrom(this.store.select(fromTeam.getEditingTeamSelector)),
    map(([{vendorUserId, vendorTeamId}, team]) => ({vendorUserId, vendorTeamId: vendorTeamId ? vendorTeamId : team.id})),
    exhaustMap(({vendorUserId, vendorTeamId}) =>
      this.jeanService
        .CreateTeamMember({
          model: {vendorUserId},
          vendorTeamId,
          version: '1',
        }).pipe(
          mergeMap(member => [
            new Members.AddTeamMemberSuccess({teamMember: member}),
            new App.ApiCallSuccess({
              title: 'Added',
              msg: 'Member was added'
            }),
          ]),
          catchError(error => of(new App.ApiCallFailure({
            title: 'Error',
            msg: 'Could not add team member'
        }))))
    ))

  @Effect()
  deleteTeamMember$ = this.actions$.pipe(
    ofType(Members.DELETE_TEAM_MEMBER),
    debounceTime(environment.debounceTime),
    map((action: Members.DeleteTeamMember) => action.payload),
    withLatestFrom(this.store.select(fromTeam.getEditingTeamSelector)),
    exhaustMap(([{teamMemberId}, team]: any) =>
      this.jeanService
        .DeleteTeamMember({
          teamMemberId,
          vendorTeamId: team.id,
          version: '1',
        }).pipe(
          mergeMap(_ => [
            new Members.DeleteTeamMemberSuccess({teamMemberId}),
            new App.ApiCallSuccess({
              title: 'Deleted',
              msg: 'Member was deleted'
            }),
          ]),
          catchError(error => of(new App.ApiCallFailure({
            title: 'Error',
            msg: 'Could not delete team member'
        }))))
    ))

  @Effect()
  loadTeamMembers$ = cacheFirst({
    store: this.store,
    actions$: this.actions$,
    type: Members.LOAD_TEAM_MEMBERS,
    selector: fromMembers.getMembersSelector
  }).pipe(
    withLatestFrom(this.store.select(fromTeam.getEditingTeamIdSelector)),
    exhaustMap(([_, vendorTeamId]) =>
      this.jeanService
        .GetTeamMembers({vendorTeamId, limit: 0, version: '1'}).pipe(
          map(members => new Members.LoadTeamMembersSuccess({members: members.items})),
          catchError(error => of(new App.ApiCallFailure({
            title: 'Error',
            msg: 'Could not load team members'
        }))))
    ))

  @Effect()
  loadTeamMember$ = this.actions$.pipe(
    ofType(Members.LOAD_TEAM_MEMBER),
    map((action: Members.LoadTeamMember) => action.payload.teamMemberId),
    withLatestFrom(this.store.select(fromTeam.getEditingTeamIdSelector)),
    exhaustMap(([teamMemberId, vendorTeamId]) =>
      this.jeanService
        .GetTeamMember({vendorTeamId, teamMemberId, version: '1'}).pipe(
        map(member => new Members.LoadTeamMemberSuccess({member})),
        catchError(error => of(new App.ApiCallFailure({
          title: 'Error',
          msg: 'Could not load team members'
        }))))
    ))
}



// WEBPACK FOOTER //
// ./src/app/shared/team/store/effects/members.effects.ts